var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 157 159",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ":root>svg{display:none}:root>svg:target{display:block}")), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 157 159",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    id: "big-correct-ans",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.537 1.111c43.099 0 78.09 34.991 78.09 78.09 0 43.099-34.991 78.09-78.09 78.09-43.099 0-78.09-34.991-78.09-78.09 0-43.099 34.991-78.09 78.09-78.09zm0 19.518c32.327 0 58.572 26.245 58.572 58.572 0 32.326-26.245 58.571-58.572 58.571-32.326 0-58.571-26.245-58.571-58.571 0-32.327 26.245-58.572 58.571-58.572zM32.892 81.192l31.229 28.611a9.759 9.759 0 0012.879.269l49.448-41.639-12.573-14.93-42.89 36.117L46.077 66.8 32.892 81.192z",
    fill: "#2d82c0"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 121 121",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    id: "correct",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.937.175c32.888 0 59.589 26.932 59.589 60.106 0 33.173-26.701 60.106-59.589 60.106S.348 93.454.348 60.281C.348 27.107 27.049.175 59.937.175zm0 16.666c23.729 0 42.922 19.504 42.922 43.44 0 23.935-19.193 43.439-42.922 43.439-23.73 0-42.923-19.504-42.923-43.439 0-23.936 19.193-43.44 42.923-43.44z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 85 85",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    id: "correct-ans",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.96 1.362c23.001 0 41.675 18.674 41.675 41.675 0 23.001-18.674 41.675-41.675 41.675C18.959 84.712.285 66.038.285 43.037c0-23.001 18.674-41.675 41.675-41.675zm0 10.417c17.252 0 31.259 14.006 31.259 31.258S59.212 74.295 41.96 74.295c-17.252 0-31.258-14.006-31.258-31.258S24.708 11.779 41.96 11.779z",
    fill: "#2d82c0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.119 40.259l16.666 15.27 26.389-22.222",
    fill: "none",
    stroke: "#2d82c0",
    strokeWidth: 10.42
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    id: "incorrect",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.937 48.196l-47.1-47.1L1.052 12.881l47.1 47.1-47.1 47.099 11.785 11.785 47.1-47.099 47.099 47.099 11.786-11.785-47.1-47.099 47.1-47.1-11.786-11.785-47.099 47.1z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 49",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    id: "menu",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M.285 48.127h56.423V37.71H.285v10.417zm0-18.591h56.423V19.12H.285v10.416zm0-18.59h56.423V.529H.285v10.417z",
    fill: "#343434"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 85 74",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    id: "questions",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.746 62.293l18.056 11.308 7.269-11.308h.961c7.486 0 12.603-6.826 12.603-15.233V16.595c0-8.407-6.078-15.233-13.564-15.233H13.85C6.363 1.362.285 8.188.285 16.595V47.06c0 8.407 6.078 15.233 13.565 15.233h30.896zm5.53-8.828l-2.537-1.589H13.85c-2.112 0-3.148-2.445-3.148-4.816V16.595c0-2.372 1.036-4.816 3.148-4.816h56.221c2.112 0 3.148 2.444 3.148 4.816V47.06c0 1.402-.266 2.718-.876 3.769-.305.526-.686 1.047-1.311 1.047h-6.648l-4.778 7.432-9.33-5.843z",
    fill: "#2c82c0"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 74 74",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    id: "settings",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.388 10.22a26.093 26.093 0 019.365 4.166l7.301-7.301 7.366 7.366-7.518 7.518a26.016 26.016 0 013.526 9.148h10.895v10.417H62.211a26.065 26.065 0 01-3.729 8.728L66.42 58.2l-7.366 7.366-7.938-7.938a26.065 26.065 0 01-8.728 3.729v11.112H31.971V61.574a26.05 26.05 0 01-9.148-3.526l-7.518 7.518L7.94 58.2l7.301-7.301a26.085 26.085 0 01-4.166-9.365H1.036V31.117h9.822a26.07 26.07 0 013.946-9.802L7.94 14.451l7.365-7.366 6.865 6.865a26.026 26.026 0 019.801-3.946V.182h10.417V10.22zm-5.745 9.784c8.712 0 15.785 7.073 15.785 15.785 0 8.711-7.073 15.784-15.785 15.784S20.859 44.5 20.859 35.789c0-8.712 7.072-15.785 15.784-15.785z",
    fill: "#343434"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 59 54",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    id: "stats",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.45 45.73V35.62H21.42v10.11h-9.73v7.5h35.49v-7.5h-9.73zM11.69 3.36l-7.57.11C2.07 3.5.43 5.17.43 7.22v21.21c0 2.07 1.68 3.75 3.75 3.75h7.51v.89c0 1.4 1.15 2.55 2.55 2.55h30.39c1.41 0 2.55-1.15 2.55-2.55v-.69h7.52c2.07 0 3.75-1.68 3.75-3.75V7.42c0-2.05-1.65-3.72-3.7-3.75l-7.57-.12v-.87c0-1.41-1.14-2.55-2.55-2.55H14.24c-1.4 0-2.55 1.14-2.55 2.55v.68zm35.49 7.69v13.83h3.77V11.11l-3.77-.06zm-35.49-.19l-3.76.06v13.76h3.76V10.86z",
    fill: "#343434"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 72",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    id: "streak",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.186 23.105c5.71 8.133 8.11 16.287 7.202 24.463v.324c-1.125 6.791-3.633 12.459-7.527 17-1.86 3.115-4.759 5.235-8.695 6.36l.065-.195c1.038-2.508 1.016-5.992-.065-10.447l-.065-.065c-3.59-9.993-7.03-16.309-10.317-18.947-.606-.52-1.233-.714-1.882-.584-.821.043-1.45.411-1.881 1.103-.39.476-.562 1.081-.52 1.817v.065c.088 4.11-1.102 7.894-3.568 11.355-3.072 3.115-4.413 6.576-4.023 10.382l.065.13c.346 2.206 1.06 4.045 2.14 5.516C7.907 68.786 1.938 62.232.208 51.72c-.822-7.57 1.817-14.47 7.916-20.699 6.187-8.305 9.127-17.412 8.825-27.318-.087-.995.152-1.817.714-2.465C18.138.502 18.787.112 19.608.07c.736-.13 1.428.087 2.077.648 9.43 7.96 15.68 17.542 18.752 28.746a15.448 15.448 0 001.428-4.867c.087-.951.497-1.709 1.233-2.27.606-.52 1.34-.693 2.206-.52.736.13 1.363.562 1.882 1.298",
    fill: "#d64a4c",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 87 85",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    id: "time-left",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.055 1.122c23.001 0 41.674 18.674 41.674 41.675 0 23.001-18.673 41.675-41.674 41.675-23.002 0-41.675-18.674-41.675-41.675 0-23.001 18.673-41.675 41.675-41.675zm0 10.417c17.251 0 31.258 14.006 31.258 31.258S60.306 74.055 43.055 74.055c-17.252 0-31.259-14.006-31.259-31.258s14.007-31.258 31.259-31.258zm-6.608 9.832v28.691H54.76V39.646h-7.897V21.371H36.447z",
    fill: "#2d82c0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.efa9a13e905f75aebf5fe62579ef786d.svg";
export { ForwardRef as ReactComponent };